import { Pipe, PipeTransform } from '@angular/core';
import { IReportTimeConfig } from '@shared/models';
import { TimePeriodService } from '@shared/services';

@Pipe({
    name: 'timePeriodSimple',
})
export class TimePeriodSimplePipe implements PipeTransform {
    constructor(private timePeriodService: TimePeriodService) {}

    transform(timeConfig: IReportTimeConfig, position: string = '', timeType: string = ''): string {
        return this.timePeriodService.getSimpleLabel(timeConfig);
    }
}
